"use strict";Object.defineProperty(exports, "__esModule", {value: true});// The backend's `validate:"uuid4"` tag (go-playground/validator), which the
// Super commands put on every key they take. It accepts lowercase only.
const UUID4 = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/

 const isUuid4 = (value) => UUID4.test(value); exports.isUuid4 = isUuid4

// A message a person can read, from whatever a Super command rejected with:
// the command's error payload (`{ Status, Error }`), a CommandError carrying
// one (wsCommand's rejections), or any other Error.
 const errorMessage = (err) => {
  const { Error: message, Status: status } = err !== null && typeof err === 'object'
    ? err 
    : {}
  if (typeof message === 'string' && message) return message
  if (err instanceof Error) return err.message
  if (typeof err === 'string' && err) return err
  if (typeof status === 'string' && status) return `Request failed (${status})`
  return 'Something went wrong'
}; exports.errorMessage = errorMessage
